import type { ActiveLoan } from "~/graphql/client"

import axiosInstance from "../api.axiosInstance"
import type {
  ActiveLoanStipulationDto,
  LoanActivityEventDto,
} from "../dto/active-loan.dto"

export class ActiveLoanApiService {
  async fetchById(activeLoanId: string): Promise<ActiveLoan> {
    const response = await axiosInstance.get<ActiveLoan>(
      `/loan-product/v1/activeloans/${activeLoanId}`,
    )

    return response.data
  }

  async fetchStipulations(
    activeLoanId: string,
  ): Promise<ActiveLoanStipulationDto[]> {
    const response = await axiosInstance.get<ActiveLoanStipulationDto[]>(
      `/v2/active-loans/${activeLoanId}/stipulations`,
    )

    return response.data
  }

  async fetchActivity(activeLoanId: string): Promise<LoanActivityEventDto[]> {
    const response = await axiosInstance.get<LoanActivityEventDto[]>(
      `/v2/active-loans/${activeLoanId}/activity`,
    )

    return response.data
  }

  async manuallyApproveCreditHumanActiveLoan(
    activeLoanId: string,
  ): Promise<ActiveLoan> {
    const response = await axiosInstance.post<ActiveLoan>(
      `/loan-product/credit-human/active-loans/${activeLoanId}/manual-approval`,
      {},
    )

    return response.data
  }
}

export const activeLoanApiService = new ActiveLoanApiService()
